import * as React from 'react';
import { brandColors, companyLogo, companyConfig } from '../config/colors';

interface ClassConfirmationEmailV3Props {
  // Dados da sessão da aula
  class_session_id?: string;
  class_session_status?: string;
  start_date?: string;
  end_date?: string;
  duration_minutes?: number;
  teams_meeting_url?: string;
  event_calendar_id?: string;
  meeting_id?: string;
  custom_meeting_url?: string;
  meeting_url_type?: string;
  mode?: string; // presencial, online, híbrido
  checked_out?: boolean;
  rescheduled_from?: string;
  
  // Dados da aula e curso
  class_id?: string;
  display_id?: string;
  course_id?: string;
  name?: string; // nome do curso
  family_name?: string;
  location_address?: string;
  status?: string;
  
  // Dados do instrutor
  instructor_id?: string;
  instructor_name?: string;
  
  // Dados do participante
  email?: string;
  participant_name?: string;
  
  // Dados da organização
  org_name?: string;
  domain?: string;
  industry?: string;
  
  // Dados da assinatura
  subscription_id?: string;
  subscription_start_date?: string;
  subscription_end_date?: string;
  state?: string;
  canceled_at?: string;
  
  // Outros
  session_count?: number;
  created_at?: string;
  updated_at?: string;
  created_by?: string;
  updated_by?: string;
}

export const ClassConfirmationEmailV3: React.FC<ClassConfirmationEmailV3Props> = ({
  class_session_id = 'CS-789012',
  class_session_status = 'confirmed',
  start_date = '2025-04-15T09:00:00Z',
  end_date = '2025-04-15T17:00:00Z',
  duration_minutes = 480,
  teams_meeting_url = 'https://teams.microsoft.com/l/meetup-join/...',
  event_calendar_id = 'CAL-123',
  meeting_id = 'MEET-456',
  custom_meeting_url = '',
  meeting_url_type = 'teams',
  mode = 'hybrid',
  checked_out = false,
  rescheduled_from = '',
  
  class_id = 'CLS-456',
  display_id = 'FA-2025-001',
  course_id = 'COURSE-123',
  name = 'Fundamentos de Data Analytics',
  family_name = 'Analytics Essentials',
  location_address = 'Av. Paulista, 1000 - Sala 203, São Paulo - SP',
  status = 'active',
  
  instructor_id = 'INST-001',
  instructor_name = 'Dra. Ana Carolina Soares',
  
  email = 'joao.silva@empresa.com.br',
  participant_name = 'João Silva',
  
  org_name = 'Empresa XYZ Ltda',
  domain = 'empresaxyz.com.br',
  industry = 'Tecnologia',
  
  subscription_id = 'SUB-789',
  subscription_start_date = '2025-01-01',
  subscription_end_date = '2025-12-31',
  state = 'active',
  canceled_at = '',
  
  session_count = 1,
  created_at = '2025-01-15T10:30:00Z',
  updated_at = '2025-01-15T10:30:00Z',
  created_by = '00000000-0000-0000-0000-000000000000',
  updated_by = '00000000-0000-0000-0000-000000000000',
}) => {
  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('pt-BR', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  };

  const formatTime = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleTimeString('pt-BR', {
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  const formatDuration = (minutes: number) => {
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    if (hours > 0) {
      return mins > 0 ? `${hours}h ${mins}min` : `${hours}h`;
    }
    return `${mins}min`;
  };

  const getModeIcon = (mode: string) => {
    switch (mode.toLowerCase()) {
      case 'online':
        return '💻';
      case 'presencial':
        return '🏢';
      case 'hybrid':
      default:
        return '🔄';
    }
  };

  const getModeText = (mode: string) => {
    switch (mode.toLowerCase()) {
      case 'online':
        return 'Online';
      case 'presencial':
        return 'Presencial';
      case 'hybrid':
      default:
        return 'Híbrido';
    }
  };

  const getStatusColor = (status: string) => {
    switch (status.toLowerCase()) {
      case 'confirmed':
        return '#c8e600';
      case 'pending':
        return '#f59e0b';
      case 'cancelled':
        return '#ef4444';
      default:
        return '#c8e600';
    }
  };

  const getStatusText = (status: string) => {
    switch (status.toLowerCase()) {
      case 'confirmed':
        return '🎉 Inscrição confirmada';
      case 'pending':
        return '⏳ Pendente';
      case 'cancelled':
        return '❌ Cancelada';
      default:
        return '🎉 Inscrição confirmada';
    }
  };

  const meetingUrl = custom_meeting_url || teams_meeting_url;
  const isRescheduled = !!rescheduled_from;

  return (
    <div style={containerStyle}>
      {/* Header */}
      <div style={headerStyle}>
        <img 
          src={companyLogo}
          alt={companyConfig.name}
          style={logoImageStyle}
        />
      </div>
      
      {/* Hero Section */}
      <div style={heroSectionStyle}>
        <div style={heroContentStyle}>
          {/* Status Badge */}
          <div style={{
            ...statusBadgeStyle,
            backgroundColor: getStatusColor(class_session_status),
          }}>
            <span>{getStatusText(class_session_status)}</span>
          </div>
          
                     <h1 style={heroTitleStyle}>
             Olá, {participant_name} 👋
           </h1>
           
                       <p style={heroSubtitleStyle}>
              Você está inscrito(a) na formação pedagógica<br />
              <span style={courseNameBoldStyle}>{name}</span>
            </p>
        </div>
      </div>

      {/* Main Content */}
      <div style={mainContentStyle}>
        
        

                 {/* Information Blocks */}
         <table style={infoTableStyle} cellPadding="0" cellSpacing="0">
           <tr>
             <td style={infoCellStyle}>
               <table style={infoBlockTableStyle} cellPadding="0" cellSpacing="0">
                 <tr>
                   <td style={infoBlockCellStyle}>
                     <div style={infoBadgeStyle}>Data</div>
                     <div style={infoValueStyle}>{formatDate(start_date)}</div>
                   </td>
                 </tr>
               </table>
             </td>
             <td style={infoCellStyle}>
               <table style={infoBlockTableStyle} cellPadding="0" cellSpacing="0">
                 <tr>
                   <td style={infoBlockCellStyle}>
                     <div style={infoBadgeStyle}>Instrutor(a)</div>
                     <div style={infoValueStyle}>{instructor_name}</div>
                   </td>
                 </tr>
               </table>
             </td>
           </tr>
         </table>

                 {/* Course Information */}
         <div style={courseSectionStyle}>
           <h2 style={sectionTitleStyle}>📚 Informações do Curso</h2>
           <div style={courseCardStyle}>
             <h3 style={courseNameStyle}>{name}</h3>
             <div style={courseFamilyStyle}>{family_name}</div>
             
                           <table style={courseMetaTableStyle} cellPadding="0" cellSpacing="0">
                <tr>
                  <td style={courseMetaCellStyle}>
                    <div style={metaLabelStyle}>ID da Aula</div>
                    <div style={metaValueStyle}>{display_id}</div>
                  </td>
                  <td style={courseMetaCellStyle}>
                    <div style={metaLabelStyle}>Modalidade</div>
                    <div style={metaValueStyle}>{getModeIcon(mode)} {getModeText(mode)}</div>
                  </td>
                  <td style={courseMetaCellStyle}>
                    <div style={metaLabelStyle}>Sessão</div>
                    <div style={metaValueStyle}>{session_count}ª aula</div>
                  </td>
                </tr>
              </table>
           </div>
         </div>

         

                 {/* Schedule Information */}
         <div style={scheduleSectionStyle}>
           <h2 style={sectionTitleStyle}>📅 Data e Horário</h2>
           <table style={scheduleTableStyle} cellPadding="0" cellSpacing="0">
             <tr>
               <td style={scheduleCellStyle}>
                 <table style={scheduleItemTableStyle} cellPadding="0" cellSpacing="0">
                   <tr>
                     <td style={scheduleItemCellStyle}>
                       <div style={scheduleIconStyle}>📆</div>
                     </td>
                     <td style={scheduleContentCellStyle}>
                       <div style={scheduleLabelStyle}>Data</div>
                       <div style={scheduleValueStyle}>{formatDate(start_date)}</div>
                     </td>
                   </tr>
                 </table>
               </td>
               <td style={scheduleCellStyle}>
                 <table style={scheduleItemTableStyle} cellPadding="0" cellSpacing="0">
                   <tr>
                     <td style={scheduleItemCellStyle}>
                       <div style={scheduleIconStyle}>🕐</div>
                     </td>
                     <td style={scheduleContentCellStyle}>
                       <div style={scheduleLabelStyle}>Horário</div>
                       <div style={scheduleValueStyle}>
                         {formatTime(start_date)} às {formatTime(end_date)}
                       </div>
                     </td>
                   </tr>
                 </table>
               </td>
             </tr>
           </table>
         </div>

        {/* Location & Meeting Information */}
        <div style={locationSectionStyle}>
          <h2 style={sectionTitleStyle}>
            {mode.toLowerCase() === 'online' ? '💻 Link da Reunião' : 
             mode.toLowerCase() === 'presencial' ? '📍 Local da Aula' : '🔄 Local e Reunião'}
          </h2>
          
          <div style={locationCardStyle}>
            {(mode.toLowerCase() === 'presencial' || mode.toLowerCase() === 'hybrid') && (
              <div style={locationInfoStyle}>
                <div style={locationLabelStyle}>📍 Endereço</div>
                <div style={locationValueStyle}>{location_address}</div>
              </div>
            )}
            
            {(mode.toLowerCase() === 'online' || mode.toLowerCase() === 'hybrid') && meetingUrl && (
              <div style={meetingInfoStyle}>
                <div style={meetingLabelStyle}>
                  🔗 {meeting_url_type === 'teams' ? 'Microsoft Teams' : 'Link da Reunião'}
                </div>
                                 <a href={meetingUrl} style={meetingLinkStyle}>
                   Participar da Reunião
                 </a>
              </div>
            )}
          </div>
        </div>

        

         {/* Organization Information */}
         <div style={orgSectionStyle}>
           <h2 style={sectionTitleStyle}>🏢 Organização</h2>
           <div style={orgCardStyle}>
             <div style={orgNameStyle}>{org_name}</div>

             <p style={partnershipTextStyle}>
               🤝 Esta formação é uma iniciativa do {org_name}, em parceria com a Trivium.
             </p>
           </div>
         </div>

                 {/* Action Buttons */}
         <div style={actionSectionStyle}>
           <div style={actionButtonsStyle}>
             {meetingUrl && (
               <a href={meetingUrl} style={primaryButtonStyle}>
                 🔗 Acessar Reunião
               </a>
             )}
           </div>
         </div>

                 {/* Welcome Message */}
         <div style={welcomeSectionStyle}>
           <div style={welcomeCardStyle}>
             <p style={welcomeTextStyle}>
               ✨ Esta será uma oportunidade de aprendizado, troca de experiências e inspiração para sua prática docente. Estamos preparando conteúdos práticos e relevantes que vão enriquecer suas aulas.
             </p>
             <p style={welcomeTextStyle}>
               Estamos animados para ter você conosco nesta jornada. 🚀
             </p>
           </div>
         </div>

         {/* Important Notes */}
         <div style={notesSectionStyle}>
           <h2 style={sectionTitleStyle}>💡 Informações Importantes</h2>
           <div style={notesCardStyle}>
             <ul style={notesListStyle}>
               <li style={notesItemStyle}>
                 ⏰ Chegue com 15 minutos de antecedência para o credenciamento
               </li>
               <li style={notesItemStyle}>
                 🆔 Traga um documento de identificação com foto
               </li>
               {mode.toLowerCase() !== 'presencial' && (
                 <li style={notesItemStyle}>
                   🎧 Teste seu áudio e vídeo antes do início da aula
                 </li>
               )}
               <li style={notesItemStyle}>
                 📱 Tenha o link da reunião salvo para acesso rápido
               </li>
               <li style={notesItemStyle}>
                 📜 Ao final do encontro, você receberá um certificado de participação
               </li>
               <li style={notesItemStyle}>
                 📧 Em caso de dúvidas, entre em contato conosco
               </li>
             </ul>
           </div>
         </div>

      </div>
      
      {/* Footer */}
      <div style={footerStyle}>
        <div style={footerContentStyle}>
          <p style={footerTextStyle}>
            🤝 Precisa de ajuda? Entre em contato conosco:
          </p>
          <div style={contactInfoStyle}>
            <span style={contactItemStyle}>✉️ {companyConfig.supportEmail}</span>
            <span style={contactItemStyle}>📱 {companyConfig.phone}</span>
          </div>
          
        </div>
        
        <hr style={footerDividerStyle} />
        
        <div style={footerBottomStyle}>
          <p style={copyrightStyle}>
            © 2025 {companyConfig.name}. Todos os direitos reservados.
          </p>
          <div style={footerLinksStyle}>
            <a href="#" style={footerLinkStyle}>Termos de Uso</a>
            <span style={footerSeparatorStyle}>|</span>
            <a href="#" style={footerLinkStyle}>Política de Privacidade</a>
          </div>
        </div>
      </div>
    </div>
  );
};

// Estilos
const containerStyle = {
  fontFamily: "'Satoshi', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  maxWidth: '600px',
  margin: '0 auto',
  backgroundColor: '#f8fafc',
  lineHeight: '1.5',
};

const headerStyle = {
  backgroundColor: brandColors.header,
  padding: '2px',
  textAlign: 'center' as const,
  borderTopLeftRadius: '12px',
  borderTopRightRadius: '12px',
};

const logoImageStyle = {
  maxWidth: '140px',
  height: 'auto',
  display: 'block',
  margin: '0 auto',
};

const heroSectionStyle = {
  backgroundColor: '#f8f9fa',
  padding: '40px 24px',
  textAlign: 'center' as const,
  color: '#2d3748',
};

const heroContentStyle = {
  maxWidth: '480px',
  margin: '0 auto',
};

const statusBadgeStyle = {
  display: 'inline-block',
  padding: '6px 12px',
  borderRadius: '12px',
  fontSize: '12px',
  fontWeight: '700',
  color: '#2d3748',
  marginBottom: '20px',
  backgroundColor: '#10b981',
};

const heroTitleStyle = {
  fontSize: '24px',
  fontWeight: '600',
  margin: '0 0 12px 0',
  color: '#2d3748',
};

const heroSubtitleStyle = {
  fontSize: '14px',
  margin: '0',
  opacity: '0.9',
  color: '#4a5568',
  lineHeight: '1.4',
};

const mainContentStyle = {
  padding: '24px',
  backgroundColor: brandColors.white,
};

const meetingDetailsStyle = {
  marginBottom: '20px',
};

const meetingTextStyle = {
  fontSize: '14px',
  color: brandColors.text,
  margin: '0',
  lineHeight: '1.5',
};

const infoTableStyle = {
  width: '100%',
  marginBottom: '24px',
  borderCollapse: 'collapse' as const,
};

const infoCellStyle = {
  width: '50%',
  padding: '0 8px',
  verticalAlign: 'top' as const,
};

const infoBlockTableStyle = {
  width: '100%',
  backgroundColor: '#f8fafc',
  borderRadius: '8px',
  border: '1px solid #e2e8f0',
};

const infoBlockCellStyle = {
  padding: '16px',
  verticalAlign: 'top' as const,
};

const infoBlockStyle = {
  padding: '16px',
  backgroundColor: '#f8fafc',
  borderRadius: '8px',
  border: '1px solid #e2e8f0',
  height: '100%',
  boxSizing: 'border-box' as const,
};

const infoBadgeStyle = {
  display: 'inline-block',
  padding: '4px 8px',
  backgroundColor: brandColors.primary,
  color: brandColors.white,
  borderRadius: '6px',
  fontSize: '11px',
  fontWeight: '500',
  marginBottom: '8px',
};

const infoValueStyle = {
  fontSize: '16px',
  fontWeight: '600',
  color: brandColors.text,
  marginBottom: '4px',
};

const infoSubtextStyle = {
  fontSize: '12px',
  color: brandColors.secondaryText,
  margin: '0',
};

const courseSectionStyle = {
  marginBottom: '20px',
};

const sectionTitleStyle = {
  fontSize: '16px',
  fontWeight: '600',
  color: brandColors.text,
  margin: '0 0 12px 0',
};

const courseCardStyle = {
  padding: '16px',
  backgroundColor: '#f8fafc',
  borderRadius: '8px',
  border: '1px solid #e2e8f0',
};

const courseNameStyle = {
  fontSize: '18px',
  fontWeight: '600',
  color: brandColors.text,
  margin: '0 0 4px 0',
};

const courseFamilyStyle = {
  fontSize: '13px',
  color: brandColors.secondaryText,
  marginBottom: '12px',
};

const courseNameBoldStyle = {
  fontSize: '16px',
  fontWeight: '700',
  color: '#2d3748',
};



const courseMetaTableStyle = {
  width: '100%',
  borderCollapse: 'collapse' as const,
  marginTop: '12px',
};

const courseMetaCellStyle = {
  width: '33.33%',
  padding: '8px 4px',
  verticalAlign: 'top' as const,
};



const metaLabelStyle = {
  fontSize: '11px',
  color: brandColors.secondaryText,
  fontWeight: '500',
  textTransform: 'uppercase' as const,
  letterSpacing: '0.5px',
  marginBottom: '4px',
};

const metaValueStyle = {
  fontSize: '13px',
  color: brandColors.text,
  fontWeight: '500',
  margin: '0',
};

const scheduleSectionStyle = {
  marginBottom: '20px',
};

const scheduleTableStyle = {
  width: '100%',
  borderCollapse: 'collapse' as const,
};

const scheduleCellStyle = {
  width: '50%',
  padding: '0 6px 0 0',
  verticalAlign: 'top' as const,
};

const scheduleItemTableStyle = {
  width: '100%',
  backgroundColor: '#f8fafc',
  borderRadius: '8px',
  border: '1px solid #e2e8f0',
  borderCollapse: 'collapse' as const,
};

const scheduleItemCellStyle = {
  width: '40px',
  padding: '12px 0 12px 12px',
  verticalAlign: 'top' as const,
};

const scheduleContentCellStyle = {
  padding: '12px 12px 12px 0',
  verticalAlign: 'top' as const,
};

const scheduleItemStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
  padding: '12px',
  backgroundColor: '#f8fafc',
  borderRadius: '8px',
  border: '1px solid #e2e8f0',
};

const scheduleIconStyle = {
  fontSize: '16px',
  width: '24px',
  textAlign: 'center' as const,
};

const scheduleContentStyle = {
  flex: '1',
};

const scheduleLabelStyle = {
  fontSize: '11px',
  color: brandColors.secondaryText,
  marginBottom: '2px',
  fontWeight: '500',
};

const scheduleValueStyle = {
  fontSize: '14px',
  color: brandColors.text,
  fontWeight: '500',
};

const locationSectionStyle = {
  marginBottom: '20px',
};

const locationCardStyle = {
  padding: '16px',
  backgroundColor: '#f8fafc',
  borderRadius: '8px',
  border: '1px solid #e2e8f0',
};

const locationInfoStyle = {
  marginBottom: '12px',
};

const locationLabelStyle = {
  fontSize: '12px',
  color: brandColors.secondaryText,
  marginBottom: '4px',
  fontWeight: '500',
};

const locationValueStyle = {
  fontSize: '14px',
  color: brandColors.text,
  fontWeight: '500',
};

const meetingInfoStyle = {
  display: 'flex',
  flexDirection: 'column' as const,
  gap: '8px',
};

const meetingLabelStyle = {
  fontSize: '12px',
  color: brandColors.secondaryText,
  fontWeight: '500',
};

const meetingLinkStyle = {
  display: 'inline-block',
  padding: '8px 16px',
  backgroundColor: brandColors.primary,
  color: brandColors.white,
  textDecoration: 'none',
  borderRadius: '6px',
  fontSize: '13px',
  fontWeight: '500',
  textAlign: 'center' as const,
  maxWidth: '200px',
};

const meetingIdStyle = {
  fontSize: '11px',
  color: brandColors.secondaryText,
  fontStyle: 'italic',
};

const orgSectionStyle = {
  marginBottom: '20px',
};

const orgCardStyle = {
  padding: '16px',
  backgroundColor: '#f8fafc',
  borderRadius: '8px',
  border: '1px solid #e2e8f0',
};

const orgNameStyle = {
  fontSize: '16px',
  fontWeight: '600',
  color: brandColors.text,
  marginBottom: '8px',
};

const orgDetailsStyle = {
  display: 'flex',
  gap: '12px',
  flexWrap: 'wrap' as const,
};

const orgDetailStyle = {
  fontSize: '12px',
  color: brandColors.secondaryText,
  fontWeight: '500',
};

const welcomeSectionStyle = {
  marginBottom: '20px',
};

const welcomeCardStyle = {
  padding: '16px',
  backgroundColor: '#ffffff',
  borderRadius: '8px',
  border: '1px solid #e2e8f0',
};

const welcomeTextStyle = {
  fontSize: '14px',
  color: '#2d3748',
  margin: '0 0 12px 0',
  lineHeight: '1.5',
};

const partnershipTextStyle = {
  fontSize: '13px',
  color: brandColors.secondaryText,
  margin: '12px 0 0 0',
  lineHeight: '1.4',
};

const actionSectionStyle = {
  margin: '24px 0',
};

const actionButtonsStyle = {
  display: 'flex',
  justifyContent: 'center',
  gap: '12px',
  flexWrap: 'wrap' as const,
};

const primaryButtonStyle = {
  display: 'inline-block',
  padding: '12px 20px',
  backgroundColor: brandColors.primary,
  color: brandColors.white,
  textDecoration: 'none',
  borderRadius: '8px',
  fontSize: '14px',
  fontWeight: '500',
  transition: 'all 0.2s ease',
  textAlign: 'center' as const,
  minWidth: '180px',
};

const secondaryButtonStyle = {
  display: 'inline-block',
  padding: '12px 20px',
  backgroundColor: brandColors.white,
  color: brandColors.primary,
  textDecoration: 'none',
  border: `1px solid ${brandColors.primary}`,
  borderRadius: '8px',
  fontSize: '14px',
  fontWeight: '500',
  transition: 'all 0.2s ease',
  flex: '1',
  textAlign: 'center' as const,
  minWidth: '180px',
};

const notesSectionStyle = {
  marginBottom: '20px',
};

const notesCardStyle = {
  padding: '16px',
  backgroundColor: '#fefce8',
  borderRadius: '8px',
  border: '1px solid #fde047',
};

const notesListStyle = {
  margin: '0',
  paddingLeft: '16px',
  color: '#92400e',
};

const notesItemStyle = {
  marginBottom: '8px',
  fontSize: '13px',
  lineHeight: '1.4',
};

const footerStyle = {
  backgroundColor: brandColors.background,
  padding: '24px',
  borderBottomLeftRadius: '12px',
  borderBottomRightRadius: '12px',
};

const footerContentStyle = {
  textAlign: 'center' as const,
  marginBottom: '20px',
};

const footerTextStyle = {
  fontSize: '13px',
  color: brandColors.secondaryText,
  margin: '0 0 12px 0',
};

const contactInfoStyle = {
  display: 'flex',
  justifyContent: 'center',
  gap: '16px',
  flexWrap: 'wrap' as const,
  marginBottom: '16px',
};

const contactItemStyle = {
  fontSize: '13px',
  color: brandColors.text,
  fontWeight: '500',
};



const footerDividerStyle = {
  border: 'none',
  borderTop: `1px solid ${brandColors.border}`,
  margin: '20px 0',
};

const footerBottomStyle = {
  textAlign: 'center' as const,
};

const copyrightStyle = {
  fontSize: '11px',
  color: brandColors.secondaryText,
  margin: '0 0 8px 0',
};

const footerLinksStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '8px',
  flexWrap: 'wrap' as const,
};

const footerLinkStyle = {
  color: brandColors.primary,
  textDecoration: 'none',
  fontSize: '9px',
  fontWeight: '500',
};

const footerSeparatorStyle = {
  color: brandColors.secondaryText,
  fontSize: '9px',
};

export default ClassConfirmationEmailV3;
